import URI from 'urijs'
import { SSR_URL } from '../../server/config'

const host = process.env.IS_BROWSER ? window.location.origin : SSR_URL

const ensureAbsoluteUrl = (input) => {
  if (typeof input !== 'string') return input
  if (URI(input).is('absolute')) return input
  return URI(host + input).normalize().toString()
}

const parseJSON = (response) => response ? response.json() : { code: 204, status: 'Ok' }

export default function fetchData(input, init) {
  input = ensureAbsoluteUrl(input)
  return fetch(input, init).then(parseJSON)
}



// WEBPACK FOOTER //
// ./src/common/lib/fetch.js